module.exports = __webpack_public_path__ + "img/IMG_9701_FoamcoreMatted.96340cda.jpg";